<section class="contact-container">
    <h1>Επικοινώνησε μαζί μας</h1>
    <article class="contact-info container">
        <h3>Kiss My Button P.C.</h3>
        <address>
            <p>Εθνικής Αντιστάσεως 33Α/55134/1ος Όροφος/Γραφεία #4, 5</p>
            <p>Θεσσαλονίκη, Ελλάδα</p>
            <p>Τηλέφωνο: <span>2111990211</span></p>
            <p>Email: <span><a href="mailto:academy@kissmybutton.gr">academy@kissmybutton.gr</a></span></p>
            <p>Facebook: <span><a href="https://www.facebook.com/profile.php?id=100083342740566" target="_blank" rel="noreferrer" aria-label="facebook">
                Kissmybutton Academy
              </a></span></p>
            <p>Instagram: <span><a href="https://www.instagram.com/kissmybutton_academy/" target="_blank" rel="noreferrer" aria-label="instagram">
                kissmybutton_academy
              </a></span></p>
            <p>Ώρες εξυπηρέτησης : 09:00 - 18:00, Δευτέρα εώς Παρασκευή</p>
        </address>
    </article>
    <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d757.490004502801!2d22.962367504712105!3d40.58663793422087!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a83f2e89177df1%3A0x9d9cd1405475a5ab!2sKissMyButton!5e0!3m2!1sel!2sgr!4v1626082642197!5m2!1sel!2sgr"
        width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
</section>